<template>
  <campo-formulario-nc/>
</template>

<script>
import campoFormularioNC from "../components/campoFormularioNC.vue";

export default {
  components: {
    "campo-formulario-nc": campoFormularioNC
  }
};
</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/screens/CalculoNC.vue